"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How does RPG-Studios approach website design?",
  answer: "We focus on creating high-performance WordPress sites that aren't just visually stunning but are built to convert. Our process integrates your brand's unique identity with the latest technology to ensure a premium, tech-forward digital presence."
}, {
  question: "What does 'building relationships' mean for my business?",
  answer: "We don't just deliver a project and disappear. We act as your long-term growth partner, providing ongoing support, expert training, and strategic advice to ensure your digital presence evolves alongside your business goals."
}, {
  question: "Can you help improve my local search visibility?",
  answer: "Absolutely. We specialize in Google Business Profile management and local SEO optimization, helping businesses in Quitman and across the region get found by the right customers exactly when they are searching for your services."
}, {
  question: "Do I need technical skills to manage my new site?",
  answer: "Not at all. Part of our service includes comprehensive client training. We'll show you exactly how to manage your content, and we're always here to handle the heavy technical lifting, security updates, and hosting for you."
}, {
  question: "How do you handle social media growth and content?",
  answer: "We combine strategic content creation with data-driven management. By understanding your audience's behavior, we craft engaging posts and multimedia content that increase visibility and build a loyal community around your brand."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="16195" id="common-growth-questions" className="dark bg-background py-24 text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent opacity-50" />
      
      <div ref={ref} className={cn("container mx-auto px-6 md:px-[10vw] transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tight mb-6 text-foreground">
            Common Growth Questions
          </h2>
          <p className="text-muted-foreground font-sans text-lg max-w-2xl mx-auto">
            Everything you need to know about our digital growth process and
            how we partner with you to revitalize your online presence.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-primary/20 rounded-none overflow-hidden bg-card/20 backdrop-blur-sm">
                <AccordionTrigger className="px-6 py-5 font-serif text-xl font-bold hover:no-underline hover:text-primary transition-colors text-left [&[data-state=open]]:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="bg-primary/5 px-6 py-6 font-sans text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground font-sans mb-6">
            Have a specific question about your project?
          </p>
          <Link to="/ContactPage" className="inline-flex h-12 items-center justify-center rounded-md bg-gradient-to-r from-[hsl(180,70%,50%)] to-[hsl(200,80%,40%)] px-10 text-sm font-serif font-bold text-background shadow-lg shadow-primary/20 transition-all hover:scale-105 hover:shadow-primary/40 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50">
            Get In Touch
          </Link>
        </div>
      </div>
    </section>;
}